import {
  CheckCircleFilled,
  FilterOutlined,
  PlusOutlined,
  UndoOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tooltip, Button, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetDesignationTableApi from "../../api/GetDesignationTableApi";
import GetFilteredDesignationApi from "../../api/GetFilteredDesignationApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddDesignationModal from "../../components/modal/add/AddDesignationModal";
import DesignationsFilterModal from "../../components/modal/filters/DesignationsFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import DesignationsTable from "../../components/tables/DesignationsTable";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function Designations(props) {
  const [canStart, setCanStart] = useState(false);
  const [canShowTable, setCanShowTable] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [data, setData] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [page, setPage] = useState(1);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    getDesignationsTable(1);
  }, []);

  async function getDesignationsTable(num) {
    setTableLoading(true);
    const apiResponse = await GetDesignationTableApi(num, LIMIT_PER_PAGE);
    console.log(apiResponse);
    if (apiResponse.message === "success") {
      if (apiResponse.designations?.length) {
        /*To show add component */
        !canShowTable && setCanShowTable(true);
      }
      setData(apiResponse);
      setCanStart(true);
      setTableLoading(false);
      setPage(num);
    }
  }

  async function getFilteredDesignations(values, num) {
    setTableLoading(true);
    const apiResponse = await GetFilteredDesignationApi(
      values.name || "",
      values.abbreviation || "",
      num,
      LIMIT_PER_PAGE
    );
    if (apiResponse.message === "success") {
      setData(apiResponse);
      setTableLoading(false);
      setFilterStatus(true);
      setFilterBy({ name: values.name, abbreviation: values.abbreviation });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilteredDesignations(filterBy, num);
    } else {
      getDesignationsTable(num);
    }
  }

  function resetFilter() {
    getDesignationsTable(1);
    setFilterStatus(false);
    setFilterBy();
  }

  const right = (
    <>
      {canShowTable && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "designations", "add") && (
        <Tooltip placement="left" title={"Add Designation"}>
          <Button
            onClick={() => setAddModal(true)}
            className="ml-3"
            shape="circle"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <div className="text-lg pri-font">
      {"Designations (" + (data?.totalCount || 0) + ")"}
    </div>
  );

  function showEmptyDesignations() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No designations available
          </div>
          {permissionAbility(userLevel, "designations", "add") && (
            <>
              <div className="mb-3 text-gray-400">
                Add different designations in your organization
              </div>
              <Button onClick={() => setAddModal(true)} type="primary">
                Add a designation
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            canShowTable ? (
              <DesignationsTable
                data={data}
                changePage={(num) => changeTablePage(num)}
                loading={tableLoading}
                page={page}
              />
            ) : (
              showEmptyDesignations()
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddDesignationModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getDesignationsTable(1)}
      />
      <DesignationsFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilteredDesignations(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default Designations;
